import {apsCommands} from "../../shared/dto/aps.commands";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import * as angular from "angular";
import {Endpoints} from "../../shared/config/constant.module";
import HttpServiceName, {HttpService} from "../http/http.service";

export interface PalletizerService {
  get(plantId: string): angular.IPromise<apsViewModels.PalletizerItem[]>;
  add(command: apsCommands.AddPalletizer): angular.IPromise<any>;
  update(command: apsCommands.UpdatePalletizer): angular.IPromise<any>;
  remove(command: apsCommands.RemovePalletizer): angular.IPromise<any>;
}

export default angular
  .module('aps.services.palletizers', [HttpServiceName])
  .service('palletizerService', palletizerService)
  .name;

function palletizerService(httpService: HttpService): PalletizerService {
  function get(plantId: string): angular.IPromise<apsViewModels.PalletizerItem[]> {
    return httpService.get<apsViewModels.PalletizerItem[]>(Endpoints.PALLETIZERS, {plantId: plantId});
  }

  function add(command: apsCommands.AddPalletizer): angular.IPromise<any> {
    return httpService.post(Endpoints.PALLETIZERS, command);
  }

  function update(command: apsCommands.UpdatePalletizer): angular.IPromise<any> {
    return httpService.put(Endpoints.PALLETIZERS, command);
  }

  function remove(command: apsCommands.RemovePalletizer): angular.IPromise<any> {
    return httpService.delete(Endpoints.PALLETIZERS + '/' + command.id,
      { plantId: command.plantId });
  }

  return {
    get: get,
    add: add,
    update: update,
    remove: remove
  };
}


// WEBPACK FOOTER //
// ./src/app/services/palletizers/palletizer.service.ts